var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolfHole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1434 5.53145L11.9626 1.2632C11.2968 0.915847 10.5 1.39885 10.5 2.14979V9.97491C10.5 9.97913 10.5 9.98334 10.5001 9.98755C10.5 9.99169 10.5 9.99584 10.5 10V18C10.5 18.5523 10.9477 19 11.5 19C12.0523 19 12.5 18.5523 12.5 18V10.6306L20.0795 7.33511C20.8507 6.99984 20.8889 5.9204 20.1434 5.53145ZM9.25 16.6372C6.20717 17.0195 4 18.1566 4 19.4999C4 21.1567 7.35786 22.4999 11.5 22.4999C15.6421 22.4999 19 21.1567 19 19.4999C19 18.1566 16.7928 17.0195 13.75 16.6372V17.9999C13.75 19.2425 12.7426 20.2499 11.5 20.2499C10.2574 20.2499 9.25 19.2425 9.25 17.9999V16.6372Z",
    fill: "#C497FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfHole);
export default __webpack_public_path__ + "static/media/golf_hole.5be101c980c26b9b585e13da77e97c83.svg";
export { ForwardRef as ReactComponent };